import { IWPImage, IWPLink } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";
import { Languages } from "@/src/types";

export type IFormData = {
  wp: {
    siteSettings: {
      siteSettings: {
        form: {
          recipient: string;
          nameLabel: string;
          companyLabel: string;
          emailLabel: string;
          phoneLabel: string;
          referralLabel: string;
          messageLabel: string;
          submitLabel: string;
          successMessage: string;
          termsLink: IWPLink;
          referralOptions: {
            label: string;
          }[];
        };
      };
    };
  };
};

const useFormData = (lang: Languages) => {
  const { wp }: IFormData = useStaticQuery(
    graphql`
      {
        wp {
          siteSettingsSV {
            acf_settings {
              form {
                recipient
                nameLabel
                companyLabel
                emailLabel
                phoneLabel
                referralLabel
                messageLabel
                submitLabel
                successMessage
                termsLink {
                  title
                  target
                  url
                }
                referralOptions {
                  label
                }
              }
            }
          }
          siteSettingsEN {
            acf_settings {
              form {
                recipient
                nameLabel
                companyLabel
                emailLabel
                phoneLabel
                referralLabel
                messageLabel
                submitLabel
                successMessage
                termsLink {
                  title
                  target
                  url
                }
                referralOptions {
                  label
                }
              }
            }
          }
          siteSettingsZH {
            acf_settings {
              form {
                recipient
                nameLabel
                companyLabel
                emailLabel
                phoneLabel
                referralLabel
                messageLabel
                submitLabel
                successMessage
                termsLink {
                  title
                  target
                  url
                }
                referralOptions {
                  label
                }
              }
            }
          }
        }
      }
    `
  );
  return wp[`siteSettings${lang.toUpperCase()}`].acf_settings.form;
};
export default useFormData;
